import React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import {
  EditSpendingPolicyDetailsFragment,
  EditSpendingPolicyRuleGroupFragment,
} from 'generated/resources/graphql'

import { CreateRuleGroupForm } from '../CreateRuleGroupForm'
import { EditRuleGroupForm } from '../EditRuleGroupForm'
import { CreateRuleGroupProps, OptionItem } from '../ruleFormHelpers'

export interface NewRuleGroupProps {
  spendingPolicy: EditSpendingPolicyDetailsFragment
  clearPendingRuleGroup: () => void
  onAdd: () => void
  pendingRuleGroup: CreateRuleGroupProps | null
  hasUnselectedCategories: boolean
  timeFrameOptions: OptionItem[]
  actionLabel: string
}
const NewRuleGroup = ({
  pendingRuleGroup,
  spendingPolicy,
  clearPendingRuleGroup,
  onAdd,
  hasUnselectedCategories,
  timeFrameOptions,
  actionLabel,
}: NewRuleGroupProps) => {
  return (
    <>
      {pendingRuleGroup && (
        <CreateRuleGroupForm
          timeFrameOptions={timeFrameOptions}
          spendingPolicy={spendingPolicy}
          onSuccess={clearPendingRuleGroup}
          onCancel={clearPendingRuleGroup}
          ruleGroup={pendingRuleGroup}
        />
      )}

      {!pendingRuleGroup && hasUnselectedCategories && (
        <Box
          onClick={onAdd}
          background="grey100"
          borderRadius={{ all: 'abs008' }}
          border={{
            all: {
              style: 'dashed',
              width: 's2',
              color: 'grey400',
            },
          }}
          paddingX="s24"
          paddingY="s12"
          justifyContent="center"
          flexDirection="row"
        >
          <Tag type="transparent" icon="add" leftItem="icon">
            {actionLabel}
          </Tag>
        </Box>
      )}
    </>
  )
}

export interface RuleGroupListProps {
  title: string
  ruleGroups: EditSpendingPolicyRuleGroupFragment[]
  timeFrameOptions: OptionItem[]
  onDelete: (ruleGroup: EditSpendingPolicyRuleGroupFragment) => void
}
const List = ({
  title,
  ruleGroups,
  children,
  timeFrameOptions,
  onDelete,
}: React.PropsWithChildren<RuleGroupListProps>) => {
  return (
    <Box gap="s24">
      <Text size="400" weight="semibold" color="textPrimary">
        {title}
      </Text>
      {ruleGroups.map((ruleGroup, index) => (
        <Box
          key={ruleGroup.id}
          border={
            index !== ruleGroups.length - 1 && {
              bottom: {
                style: 'solid',
                width: 's1',
                color: 'grey400',
              },
            }
          }
        >
          <EditRuleGroupForm
            onDelete={onDelete}
            timeFrameOptions={timeFrameOptions}
            ruleGroup={ruleGroup}
          />
        </Box>
      ))}
      {children}
    </Box>
  )
}

export const RuleGroup = {
  New: NewRuleGroup,
  List,
}
